import { useState, useEffect } from "react";

export const useFeatureValue = (featureKey, defaultValue = null) => {
  const getValueFromGb = () => {
    const gb = window.growth_book;
    if (!gb) return defaultValue;
    return gb.getFeatureValue(featureKey, defaultValue);
  };

  const [value, setValue] = useState(getValueFromGb);

  useEffect(() => {
    const update = (gb) => {
      const next = gb.getFeatureValue(featureKey, defaultValue);
      setValue(prev => prev === next ? prev : next);
    };

    const onReady = () => {
      const gb = window.growth_book;
      update(gb);
      gb.subscribe(() => update(gb));
    };

    if (window.growth_book) {
      onReady();
    } else {
      window.addEventListener('growthbook:ready', onReady, { once: true });
      return () => window.removeEventListener('growthbook:ready', onReady);
    }
  }, [featureKey]);

  return value;
};
